var map = {
	"./kayaking-img-1.jpg": 762,
	"./no-data.svg": 3275,
	"./original-authors.md": 3307,
	"./page-not-found.svg": 2057,
	"./scuba-diving-vid-1.mp4": 7804,
	"./ski-resort-img-1.jpg": 5798,
	"./ski-resort-img-2.jpg": 6695,
	"./snowboarding-img-1.jpg": 7200,
	"./solstice-logo-coloured.svg": 2243,
	"./solstice-logo-light.svg": 2928,
	"./surfing-img-1.jpg": 8737,
	"./travel-tips-img-1.jpg": 7955
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;